import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { type FC, useCallback } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import { FilterDropdown } from "~/components/UI/FilterDropdown";
import { SubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard";
import { useSubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard/useSubscriptionGuard";
import { ApyFilterEnum } from "~/types/apy";
import { FeatureKey } from "~/types/subscription";

import { APY_TOOLTIP_TEXT, apyFilterOptions } from "./constants";

export const ApyFilter: FC = () => {
  const { filters, updateFilters } = useFiltersScope();
  const { isLocked } = useSubscriptionGuard(FeatureKey.APY_FILTER);

  const onChange = useCallback(
    (apyFilter?: ApyFilterEnum) => {
      updateFilters({ apyFilter });
    },
    [updateFilters]
  );

  return (
    <SubscriptionGuard featureKey={FeatureKey.APY_FILTER}>
      <FilterDropdown
        label="Min APY"
        icon={<TrendingUpIcon fontSize="inherit" />}
        tooltip={APY_TOOLTIP_TEXT}
        locked={isLocked}
        options={apyFilterOptions}
        defaultValue={ApyFilterEnum.ALL}
        value={filters.apyFilter ?? ApyFilterEnum.ALL}
        onChange={onChange}
      />
    </SubscriptionGuard>
  );
};
